import Home from '@/components/frame/Home'

const home = {
  isShow: true,
  index: 2,
  path: '/enterpriseManagement',
  component: Home,
  redirect: '/enterpriseManagement/index',
  name: 'enterpriseManagement',
  isHead: true,
  meta: {
    title: '一企一档',
    icon: 'el-icon-s-management'
  },
  children: [
    {
      path: 'index',
      component: () => import('@/views/enterpriseManagement/managementPage'),
      name: 'EnterpriseManagement',
      meta: { title: '一企一档', close: true }
    }
  ]
}

export default home


// WEBPACK FOOTER //
// ./src/router/modules/enterpriseManagement.js